import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontSizes, fontWeights, lineHeights, media, radii, space } = theme

export const Section = styled.section`
  box-sizing: border-box;
  width: 100%;
  padding: ${space['spacing-xxxl']} 0;
  background-color: #f4f6fb;

  @media (${media.tablet}) {
    padding: ${space['spacing-giga']} 0;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  width: calc(100% - ${space['spacing-xxl']});
  max-width: 900px;
  margin: 0 auto;

  .ds-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: ${space['spacing-mega']};
    margin: 0 auto;
    border-radius: ${radii['corner-radius-pill']};
    background-color: ${colors['blue-background-strong-default']};
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-xl']};

    .ds-button {
      width: 21.875rem;
    }
  }
`

export const Heading = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  h2 {
    margin: 0;
    font-size: ${fontSizes['font-size-mobile-heading-2']};
    line-height: ${lineHeights['font-line-height-md']};
    letter-spacing: -0.72px;
    text-align: center;
  }

  @media (${media.tablet}) {
    h2 {
      font-size: ${fontSizes['font-size-heading-2']};
      line-height: ${lineHeights['font-line-height-sm']};
      letter-spacing: -0.4px;
    }
  }
`

export const Highlight = styled.span`
  display: block;
  color: ${colors['pink-text-contrast']};
  font-weight: ${fontWeights['font-weight-bold']};
`

export const Intro = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  p {
    margin: 0;
    text-align: center;
  }

  @media (${media.tablet}) {
    p {
      font-size: ${fontSizes['font-size-body-small']};
      line-height: ${lineHeights['font-line-height-lg']};
    }
  }
`

export const TableScroller = styled.div`
  width: 100%;
  margin: 0;
  overflow: visible;

  @media (${media.tablet}) {
    width: 900px;
    max-width: 100%;
    margin: 0 auto;
  }
`

export const TableShell = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #e4e9f2;
  border-radius: 24px;
  background-color: #f4f4f8;

  @media (${media.tablet}) {
    width: 900px;
    max-width: 100%;
  }
`

export const TableViewport = styled.div`
  overflow: hidden;
  border-radius: 20px;
`

export const Badge = styled.span`
  position: absolute;
  z-index: 2;
  top: -16px;
  left: 46%;
  padding: 5px ${space['spacing-sm']};
  border-radius: ${radii['corner-radius-pill']};
  background-color: ${colors['pink-text-contrast']};
  color: ${colors['neutral-text-contrast-default']};
  font-size: 12px;
  font-weight: ${fontWeights['font-weight-bold']};
  line-height: 1;
  white-space: nowrap;
  transform: translateX(-50%);

  @media (${media.tablet}) {
    left: 41.67%;
  }
`

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  background-color: ${colors['neutral-background-default']};
  table-layout: fixed;

  caption {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip-path: inset(50%);
    border: 0;
    white-space: nowrap;
  }

  col:first-child {
    width: 28%;
  }

  col:nth-child(2),
  col:nth-child(3) {
    width: 36%;
  }

  th,
  td {
    box-sizing: border-box;
    min-height: ${space['spacing-mega']};
    padding: ${space['spacing-xs']};
    border-bottom: 1px solid ${colors['neutral-border-weak']};
    background-color: ${colors['neutral-background-default']};
    color: ${colors['neutral-text-default']};
    font-size: 12px;
    line-height: 1.3;
  }

  thead th {
    font-size: 12px;
    font-weight: ${fontWeights['font-weight-bold']};
    line-height: ${lineHeights['font-line-height-md']};
    text-align: center;
    vertical-align: bottom;
  }

  tbody th {
    font-size: 12px;
    font-weight: ${fontWeights['font-weight-bold']};
    text-align: right;
  }

  tbody td {
    color: ${colors['neutral-text-weak']};
    font-weight: ${fontWeights['font-weight-regular']};
    text-align: left;
  }

  thead th:nth-child(2),
  tbody td:nth-child(2) {
    border-bottom-color: rgb(255 255 255 / 12%);
    background-color: ${colors['cashme-dark-blue']};
    color: ${colors['neutral-text-contrast-default']};
  }

  thead th:nth-child(2) {
    border-radius: 8px 8px 0 0;
    color: ${colors['cashme-blue-neon']};
  }

  tbody tr:last-child th,
  tbody tr:last-child td {
    border-bottom: 0;
  }

  tbody tr:last-child td:nth-child(2) {
    border-radius: 0 0 8px 8px;
  }

  @media (${media.tablet}) {
    col:first-child {
      width: 200px;
    }

    col:nth-child(2),
    col:nth-child(3) {
      width: 350px;
    }

    th,
    td {
      height: ${space['spacing-mega']};
      padding: ${space['spacing-sm']};
      font-size: 14px;
    }

    thead th {
      font-size: 15px;
    }

    tbody th {
      font-size: 14px;
    }
  }
`
